import { FC } from 'react';
import { Button } from 'atoms/Button';
import { Icon, IconType } from 'atoms/Icon';
import { P } from 'atoms/Typography';
import { useFilters } from 'organisms/Filters/hooks';
import { useTranslations } from 'modules/i18n/useTranslations';
import styles from './styles.module.css';

export const Mobile: FC<{ active: boolean; onClick: () => void }> = ({
  active,
  onClick,
}) => {
  const t = useTranslations();
  const { filters } = useFilters();

  return (
    <Button className={styles.root} onClick={onClick}>
      <P className={styles.text}>
        {t('search.filter')} ({filters?.length})
      </P>
      <Icon
        type={IconType[active ? 'close' : 'filter']}
        className={styles.icon}
      />
    </Button>
  );
};
